<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button title="back page" (click)="backToLeaveAdjustment()">
                                    <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3>Comp-Off Adjustments Detail</h3>
                            </div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button title="Edit" type="button" data-bs-toggle="modal" (click)="editOpenModal()" data-bs-target="#adjustmentCompOff">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="row p-0">
                            <div class="col-sm-12 p-0">
                                <div class="canvas-data px-0">
                                    <form [formGroup]="employeeDetailsForm">
                                        <div class="row m-0">
                                            <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                                                <div class="input">
                                                    <div class="input-item">
                                                    <input list="userDropdownList" formControlName="userId"
                                                        placeholder="Select Employee Name" value="" onfocus="this.value=''"
                                                        onchange="this.blur();" />
                                                    <datalist id="userDropdownList">
                                                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                                    </datalist>
                                                    <label class="floating-label">Employee Name</label>
                                                    <i class="ri-user-line"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 text-end text-right">
                                                <div class="row justify-content-center">
                                                    <div class="col-sm-6">
                                                        <button type="button" class="btn" (click)=getCompOffSummary()>
                                                            <div>Submit</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: calc(100vh - 290px) !important;" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Disabled Date Modal -->
<div class="modal fade" id="adjustmentCompOff" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup] = "compOffAdjustmentsForm">
                <div class="modal-header">
                    <h5 class="modal-title">Comp-Off Adjustments</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">  
                            <div class="input">
                                <div class="input-item">
                                    <input list="text" formControlName="employeeId" disabled/>
                                    <label class="floating-label-special">Employee Name*</label>
                                    <i class="ri-user-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">  
                            <div class="input">
                                <div class="input-item">
                                    <input list="text" formControlName="balance" required/>
                                    <label class="floating-label-special">Balance*</label>
                                    <i class="ri-user-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="validityDate"/>
                                    <label class="floating-label-special">Validity Date*</label>
                                    <i class="ri-user-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModal" type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="updateCompOff()">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>